import { render, staticRenderFns } from "./report-manage.vue?vue&type=template&id=10d6a69a"
import script from "./report-manage.vue?vue&type=script&lang=js"
export * from "./report-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports